import CampaignDetailModal from "./CampaignDetailModal";
import CampaignDetailsCard from "./CampaignDetailsCard";
import { useState } from "react";
import TaxonomyComplianceCard from "./TaxonomyComplianceCard";

const CampaignDetailInfoCards = ({ campaignDetails, taxonomyCompliance }) => {
  const [showCampaignDetailModal, setShowCampaignDetailModal] = useState(false);

  const toggleCampaignDetailModal = () => {
    setShowCampaignDetailModal(!showCampaignDetailModal);
  }

  return (<>
    {showCampaignDetailModal && <CampaignDetailModal {...campaignDetails} onClose={toggleCampaignDetailModal} />}
    <div className="campaign-detail-info-cards">
      <CampaignDetailsCard {...campaignDetails} toggleCampaignDetailModal={toggleCampaignDetailModal} />
      <TaxonomyComplianceCard {...taxonomyCompliance} />
    </div>
  </>
  );
};

export default CampaignDetailInfoCards;
